import React from 'react';
import FeedPhotosItem from './FeedPhotosItem2';
import styles from './FeedPhotos.module.css';
import { useSelector } from 'react-redux';

const FeedPhotos2 = ({ setModalPhoto }) => {
  const { list } = useSelector((state) => state.feed2);
  return (
    <ul className={`${styles.feed} animeLeft`}>
      {list.map((photo) => (
        <FeedPhotosItem
          key={photo.id}
          photo={photo}
          setModalPhoto={setModalPhoto}
        />
      ))}
    </ul>
  );
};

export default FeedPhotos2;
